export class ValidateResult {
    constructor() {
        Object.defineProperty(this, "errors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "isValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
    pushErrorMessage(message) {
        this.errors.push(message);
        this.isValid = false;
    }
}
